<!-- 右边悬浮栏 -->
<template>
  <div class="rightbar">

    <!-- 内容 -->
    <div class="content">
      <template v-for="(item, index) in iconList">
        <div class="content_item" v-if="item.isShow()" :key="index" @click.stop="item.eventFn"
          @mouseleave="itemHover(item.name)" @mouseenter="itemHover(item.name)">
          <span :class="['iconfont', item.icon]"></span>
          <div class="text">{{ item.name }}</div>
        </div>
      </template>

      <!-- 在线客服弹窗 -->
      <div class="contact_poup" v-if="contactVisible">
        <div style="color: #151b48;font-size: 14px;font-weight: bold;text-align: center;">
          <p>专属客服</p>
        </div>
        <el-image src="https://static.xueyanhui.com/static/wechatQrc/326829baefad42a8a2290b56f489ee77.png"></el-image>
      </div>
    </div>



    <!-- 回到顶部按钮 -->
    <div class="back_top" v-if="isShowTop" @click="backTop">
      <img src="@/assets/imgs/homeIcon/top.png" alt="" class="top_icon" />
      <div class="text">回到顶部</div>
    </div>

    <!-- 评价晒单 -->
    <div class="evaluate" 
    :class="isShowTop && 'evaluate_bottom'"
    @click="jumpEvaluate" v-if="showEvaluateEntry">
      <img src="@/assets/imgs/homeIcon/evaluate.png" alt="">
    </div>
  </div>
</template>

<script>
// import { userCount, backTop } from "@/tool";
import {getEvaluateActivity} from "@/api/activity";
import { backTop } from "@/tool";
export default {
  components: {
  },
  data() {
    return {

      // 是否展示评价活动入口
      showEvaluateEntry:false,

      showGZH: false,
      showCustomer: false,
      contactVisible: false,
      iconList: [
        {
          name: "个人中心",
          eventFn: () => {
            this.$router.push("/myCenter/centerHome");
          },
          // icon: "icon-a-Group5422",
          isShow: () => {
            return true;
          },
        },

        {
          name: "在线客服",
          eventFn: () => {
            this.contactVisible = true
          },
          // icon: "icon-caogaoxiang",
          isShow: () => {
            // return this.$route.path == "/nmMaterial";
            return true;
          },
        },
        {
          name: "IF查询",
          eventFn: () => {
            this.$router.push("/IFqueryView");
          },
          // icon: "icon-caogaoxiang",
          isShow: () => {
            // return this.$route.path == "/nmMaterial";
            return true;
          },
        },
        {
          name: "分区查询",
          eventFn: () => {
            this.$router.push("/partitionQueryView");
          },
          // icon: "icon-caogaoxiang",
          isShow: () => {
            // return this.$route.path == "/nmMaterial";
            return true;
          },
        },
        {
          name: "通用项目",
          eventFn: () => {
            this.$router.push("/details/1");
          },
          // icon: "icon-caogaoxiang",
          isShow: () => {
            // return this.$route.path == "/nmMaterial";
            return true;
          },
        },

      ],
      isShowTop: true,
    };
  },
  mounted() {
    let that = this;
    window.addEventListener(
      "scroll",
      function () {
        let app = this.document.getElementById("app");
        if (app) {
          let top = Math.floor(app.scrollTop);
          top > 980 ? (that.isShowTop = true) : (that.isShowTop = false);
        }
      },
      true
    );
    this.$EventBus.$on("hidePopover", () => {
      this.hideAll();
    });
    //这段代码循环触发
    this.getEvaluateStarFn()
  },
  computed: {},
  methods: {

    getEvaluateStarFn(){
      getEvaluateActivity().then(res=>{

        if(res) {this.showEvaluateEntry = true}
      })
    },

    jumpEvaluate() {
      this.$router.push("/evaluate");
    },
    itemHover(name) {
      if (name == "公众号") {
        this.showGZH = !this.showGZH;
      }
      if (name == "在线客服") {
        this.contactVisible = !this.contactVisible
      }
    },
    hideAll() {
      this.showComplainDialog = false;
      this.showGZH = false;
      this.showCustomer = false;
    },
    showPopover() {
      this.showCustomer = !this.showCustomer;
      this.showGZH = false;
    },
    backTop,
    // backTop() {
    //   //回到顶部方法 点击按钮调用
    //   // let top = document.documentElement.scrollTop || document.body.scrollTop;

    //   let dom = document.getElementById("app");
    //   let top = dom.scrollTop;
    //   // 实现滚动效果
    //   const timeTop = setInterval(() => {
    //     dom.scrollTop = top -= 50;
    //     if (top <= 0) {
    //       clearInterval(timeTop); //清除定时器
    //     }
    //   }, 10);
    // },
  },
};
</script>

<style lang="less" scoped>
.rightbar {
  width: 80px;
  position: fixed;
  bottom: 225px;
  right: 20px;
  font-size: 12px;
  color: #000;
  z-index: 999;

  // 隐藏
  .hide {
    display: none;
  }

  .iconfont {
    font-size: 26px;
  }

  .text {
    font-size: 14px;
  }

  .customer,
  .back_top {
    width: 100%;
    height: 74px;
    border-radius: 12px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    box-shadow: -3px 4px 7px 1px rgba(0, 0, 0, 0.08);
    cursor: pointer;

    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
    font-weight: bold;
    font-size: 14px;
    color: #100926;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .top_icon {
      width: 20px;
      height: 20px;
      margin-bottom: 12px;
    }
  }

  .customer {
    color: #fff;
    position: relative;
    box-shadow: -3px 4px 7px 1px rgba(0, 0, 0, 0.08);
    background-color: @main-color;

    .server_content {
      width: 260px;
      background-color: #fff;
      position: absolute;
      left: -270px;
      padding: 20px 0 0 20px;

      box-shadow: -3px 4px 7px 1px rgba(0, 0, 0, 0.08);

      .title {
        color: #171717;
        margin-bottom: 8px;

        .iconfont {
          color: @main-color;
          font-size: 26px;
          margin-right: 7px;
          font-weight: 400;
        }
      }

      .text {
        color: #777777;
        font-size: 16px;
        font-weight: 700;
      }

      .item {
        margin-bottom: 12px;

        .top {
          display: flex;
          align-items: center;

          .dot {
            margin-right: 13px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: @main-color;
          }

          .text {
            color: @main-color;
            font-weight: 400;
          }
        }

        .bottom {
          color: @main-color;

          font-weight: 700;
          font-size: 16px;
          text-align: left;
          margin-bottom: 10px;
          margin-left: 22px;
        }
      }
    }
  }

  // .customer:hover {
  //   .server_content {
  //     display: block;
  //     display: block;
  //     opacity: 1;
  //   }
  // }
  .content {
    position: relative;
    width: 100%;
    background-color: #fff;
    padding: 0 10px;
    border-radius: 12px;
    box-shadow: -3px 4px 7px 1px rgba(0, 0, 0, 0.08);
    margin-bottom: 18px;

    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
    font-weight: bold;
    font-size: 14px;
    color: #151b48;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .content_item {
      height: 46px;
      line-height: 46px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      border-bottom: 1px solid #f3f3f4;
      position: relative;

      &:hover {
        color: @main-color;
      }

      .popover {
        width: 180px;
        padding: 12px 0;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;

        position: absolute;
        left: -200px;
        top: -20px;

        img {
          width: 112px;
        }
      }
    }

    .content_item:last-child {
      border: 0;
    }

    .contact_poup {
      width: 200px;
      height: 240px;
      background-color: #fff;
      position: absolute;
      left: -220px;
      top: -50px;
      border-radius: 12px;
      padding:0 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .title {
        font-weight: 500;
        font-size: 20px;
        margin-right: 12px;
      }

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }

      .tels {
        .item {
          margin-bottom: 20px;

          .txt {
            color: #6e39de;
          }

          &.item:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .contact_poup::after {
      content: '';
      position: absolute;
      top: 50%;
      right: -8px;
      /* Adjust based on triangle size */
      margin-top: -10px;
      /* Half of triangle height */
      border-width: 10px 0 10px 10px;
      /* Adjust sizes to create desired triangle */
      border-style: solid;
      border-color: transparent transparent transparent white;
      /* transparent on left to create triangle */
      z-index: -1;
      /* To place triangle behind the square */
    }
  }
}


.evaluate{
  width: 132px;
  height:54px;
  position: absolute;
  right: 0;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
  }
}

.evaluate_bottom{
  bottom: -65px;
}
</style>
